import { render, staticRenderFns } from "./CustomGroupRadioField.vue?vue&type=template&id=3c000fe8&scoped=true&"
import script from "./CustomGroupRadioField.vue?vue&type=script&lang=js&"
export * from "./CustomGroupRadioField.vue?vue&type=script&lang=js&"
import style0 from "./CustomGroupRadioField.vue?vue&type=style&index=0&id=3c000fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c000fe8",
  null
  
)

export default component.exports